function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.965 1.635H.445c-.245 0-.445.2-.445.446v8.473C0 10.8.2 11 .446 11h.922V8.176c0-.247.2-.446.446-.446h1.783c.247 0 .446.2.446.446V11h1.368V2.081c0-.246-.2-.446-.446-.446zM2.259 6.392a.446.446 0 01-.891 0v-.595a.446.446 0 01.891 0v.595zm0-2.378a.446.446 0 01-.891 0v-.595a.446.446 0 11.891 0v.595zm1.784 2.378a.446.446 0 01-.892 0v-.595a.446.446 0 01.892 0v.595zm0-2.378a.446.446 0 01-.892 0v-.595a.446.446 0 01.892 0v.595z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.26 8.622h.891V11H2.26V8.622zM9.202 0H8.16a.446.446 0 00-.442.39l-.49 3.92h2.905L9.644.39A.446.446 0 009.202 0zM11.88.39l-.49 3.92h2.906l-.49-3.92a.446.446 0 00-.442-.39h-1.04a.446.446 0 00-.443.39zM14.776 5.203H6.303V11h1.932V8.77c0-.246.2-.446.446-.446h4.162c.247 0 .446.2.446.446V11h1.487c.246 0 .446-.2.446-.446V5.649c0-.247-.2-.446-.446-.446zM8.68 7.433h-.594a.446.446 0 010-.893h.594a.446.446 0 010 .892zm2.379 0h-.595a.446.446 0 010-.893h.595a.446.446 0 010 .892zm2.378 0h-.595a.446.446 0 110-.893h.595a.446.446 0 010 .892z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.127 9.216h3.27V11h-3.27V9.216z",
  fill: "#fff"
});

function SvgIconSiteSelectionSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgIconSiteSelectionSmall;